export const PROPERTIES_RECEIVED = 'PROPERTIES_RECEIVED'
export const PROPERTIES_UNLOADED = 'PROPERTIES_UNLOADED'

export const PROPERTY_SAVED = 'PROPERTY_SAVED'
export const PROPERTY_DELETED = 'PROPERTY_DELETED'
